import {
  Component,
  effect,
  EventEmitter,
  inject,
  input,
  InputSignal,
  OnInit,
  Output,
  signal
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { PromptComponent, Validation } from '@k12/models';
import { DnpeLookupValidator } from './dnpe-lookup.validator';
import { DnpeService } from '@k12/app-services';

@Component({
  selector: 'lib-pc-dnpe-lookup',
  imports: [MatError, MatFormField, MatInput, ReactiveFormsModule],
  templateUrl: './pc-dnpe-lookup.html',
  styleUrl: './pc-dnpe-lookup.scss'
})
export class PcDnpeLookupComponent implements OnInit {
  configJson = input<PromptComponent>({} as PromptComponent);
  enrollmentBuilderView: InputSignal<boolean> = input<boolean>(true);

  @Output() cbConfig = new EventEmitter();
  @Output() dnpeLookup = new EventEmitter();

  public dnpe = signal<FormControl>({} as FormControl);

  private readonly dnpeService = inject(DnpeService);
  protected readonly Validation = Validation;

  constructor() {
    effect(() => {
      if (this.configJson().inputs) {
        this.dnpe.set(
          new FormControl(
            { value: '', disabled: this.enrollmentBuilderView() },
            {
              validators: [
                Validators.required,
                Validators.minLength(this.configJson().inputs[0].min ?? 5),
                Validators.maxLength(this.configJson().inputs[0].max ?? 6)
              ],
              asyncValidators: DnpeLookupValidator(this.dnpeService),
              updateOn: 'change'
            })
        );

        this.dnpe().statusChanges.subscribe(status => {
          this.dnpeLookup.emit({
            formName: this.configJson().id ?? '',
            control: { [this.configJson().inputs[0].id ?? '']: status === 'VALID' ? this.dnpe().value : ''},
          });
        })
      }
    });
  }

  ngOnInit() {
    this.cbConfig.emit(this.configJson());
  }
}
